import { useState } from 'react';

import { HeroBanner } from './components/HeroBanner';
import { SiteFooter } from './components/SiteFooter';
import { SocialLinks } from './components/SocialLinks';
import { WaitlistCard } from './components/WaitlistCard';
import { cx } from './lib/cx';
import { hasConfirmedFlag } from './lib/confirmation';
import { FADE_UP } from './styles/animation';
import styles from './App.module.css';

/**
 * The description doubles as the call to action, so it changes once there is
 * nothing left to ask for.
 */
const DESCRIPTION = {
  signup:
    'Anyone worth discovering, on one board — and the reach that drives your business and your popularity. Join the waitlist to claim your spot at launch.',
  confirmed:
    'Anyone worth discovering, on one board — and the reach that drives your business and your popularity.',
} as const;

export function App() {
  // Read once on mount: the URL cannot change without a full page load, so
  // re-reading it on every render would be wasted work.
  const [confirmed] = useState(hasConfirmedFlag);

  return (
    <>
      <HeroBanner label="Coming soon" />

      <main className={styles.main}>
        <div className={styles.content}>
          <h1 className={cx(FADE_UP, styles.headline)}>
            One place to be
            <br />
            <span className={styles.accent}>discovered.</span>
          </h1>

          <p className={cx(FADE_UP, styles.description)}>
            {confirmed ? DESCRIPTION.confirmed : DESCRIPTION.signup}
          </p>

          <WaitlistCard confirmed={confirmed} />
          <SocialLinks />
        </div>
      </main>

      <SiteFooter />
    </>
  );
}
